export const baseUrl = '/registration-documents'
